<template>
    <div>

        <!-- Tabs and struct -->

        <trax-ui-vertical-dynamic-tabs :tabs="tabs" :id="id+'-tabs'" :bus="bus" class="pt-3 pb-3">
            <trax-ui-ajax-struct-with-actions :id="id" :bus="bus" :endpoint="endpoint" 
                :new-item-label="newItemLabel" :new-category-label="newCategoryLabel" 
                :new-title-label="newTitleLabel" :index-id="indexId" drag="1">
            </trax-ui-ajax-struct-with-actions>
        </trax-ui-vertical-dynamic-tabs>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id+'-edit'" :bus="bus">
            <trax-ui-struct-item-form :id="id+'-edit'" :toastr-id="id+'-toastr'" :bus="bus" :endpoint="endpoint"
                :item-rows="3">
            </trax-ui-struct-item-form>
        </trax-ui-modal-default>

        <!-- Delete confirm modal -->

        <trax-ui-modal-confirm :id="id+'-delete'" :title="lang.polaris.form.deletion" :bus="bus">
            {{ lang.polaris.form.confirm_delete_q }}
        </trax-ui-modal-confirm>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>
    
    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'trax-training-competency-item'},
            newItemLabel: {default: lang.polaris.training.new_competency_item},
            newTitleLabel: {default: lang.polaris.training.new_competency_title},
            newCategoryLabel: {default: lang.polaris.training.new_competency_set},
            indexId: null
        },
    
        data: function() {
            return {
                lang: lang,
                endpoint: app_url+"polaris/api/front/competency-items",
                tabs: data.competency_item_types_select,
                bus: new Vue()
            }
        }
    }
</script>
